export const getReferenceDocumentsApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/reference-documents${queryString ? `?${queryString}` : ""}`;
};

export const addReferenceDocumentsApi = (params) => {
    return `lease/${params?.leaseSlug}/reference-documents`;
}

export const updateReferenceDocumentsApi = (params) => {
    return `lease/${params?.leaseSlug}/reference-documents/${params?.slug}`;
};

export const deleteReferenceDocumentApi = (params) => {
    return `lease/${params?.leaseSlug}/reference-documents`;
};

export const referenceDocumentfileUploadPostApi = (lease_slug) => {
    return `/get-pre-signed-url/reference_document/${lease_slug}`;
};

export const updateAttachmentMetaData=(attachments_slug)=>{
    return `update-attachment-metadata/reference_document/${attachments_slug}`
}